import { combineReducers } from 'redux';
import * as appReducers from './App/reducers';
import * as authenticationReducers from './Authentication/reducers';
import * as formReducers from './Form/reducers';

export default combineReducers({
    ...appReducers,
    ...authenticationReducers,
    ...formReducers
})